import { render, staticRenderFns } from "./UnitDetailRowItem.vue?vue&type=template&id=42c8284d&scoped=true&"
import script from "./UnitDetailRowItem.vue?vue&type=script&lang=js&"
export * from "./UnitDetailRowItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c8284d",
  null
  
)

export default component.exports